//@ts-nocheck
import React from "react";
import { Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { textColor } from "../../../utils/commonstyle";
import ButtonComponents from "../../commonComponents/ButtonComponents";

const Emailvalidation = () => {
  const navigate = useNavigate();
    const handletryAgain = () => {
        navigate("/kyc-kyb/identity-verification");
    }
  return (
    <Box
      sx={{
        maxWidth: { xs: "90%", md: "45%" },
        mx: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: { xs: "80vh", md: "65vh" },
        boxShadow: 1,
        bgcolor: "background.paper",
        textAlign: "center",
        p: 4,
        mt: 1,
      }}
      data-testid="identity-verification-container"
    >
      <Typography
        variant="h5"
        component="h5"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1.25rem", md: "26px" },
          color: "text.primary",
          mb: 2,
        }}
        data-testid="verification-title"
      >
        Too many requests
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: "0.875rem", md: "1rem"},
          color: textColor.fontColor,
        }}
        data-testid="verification-notification"
      >
        We have noticed an unusually high number of transactions in a short period. <br/> Please try again later or contact customer support
        <Typography
          component="span"
          sx={{
            fontSize: { xs: "0.875rem", md: "1rem"},
            color: textColor.primaryColor,
            mx: 0.5,
          }}
          data-testid="email-address"
        >
          <a href="mailto:auction.customerservice@xome.com" style={{ color: textColor.primaryColor }}>
          auction.customerservice@xome.com
          </a>
        </Typography>.
      </Typography>
      <ButtonComponents
          label="Try Again"
          onClick={handletryAgain}
          sx={{
            my:2,
            backgroundColor: '#FF5C39',
            color: '#fff',
            '&:hover': { backgroundColor: '#e65232' },
          }}
          data-testid="try-again-button"
        />
    </Box>
  );
};

export default Emailvalidation;
